import { render, staticRenderFns } from "./SelfBuildCategory.vue?vue&type=template&id=98c92c3c&scoped=true&"
import script from "./SelfBuildCategory.vue?vue&type=script&lang=js&"
export * from "./SelfBuildCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelfBuildCategory.vue?vue&type=style&index=0&id=98c92c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c92c3c",
  null
  
)

export default component.exports